export default {
    unities: [],
    platforms: [],
    users: [],
    leads: [],
    retainedLeads: null
};